import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next/pages';
import { Wrapper } from '@ev-tech/ui-core-components/Wrapper';
import { Headline } from '@ev-tech/ui-core-components/Headline';

import { formatWithCount } from '@/utils/formatters';
import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useShouldHideUserAccountExclusiveContent } from '@/hooks/useShouldHideUserAccountExclusiveContent';
import { useIsScrolled } from '@/hooks/useScrollTriggers';
import { useListing } from '@/hooks/queries/useListing';

import { FloorPlanPlaceholder } from '../FloorPlanImageSlider/FloorPlanPlaceholder';

import styles from './FloorPlanSection.module.css';

const FloorPlanImageSlider = dynamic(() => import('../FloorPlanImageSlider/FloorPlanImageSlider').then((mod) => mod.FloorPlanImageSlider), {
  loading: () => <FloorPlanPlaceholder />,
});

export const DynamicFloorPlanSection = () => {
  const isUAExclusiveListingAndNotSignedIn = useShouldHideUserAccountExclusiveContent();
  const {
    data: { listing },
  } = useListing();

  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);
  const shouldLoadLazyLoadedComponent = useIsScrolled({ threshold: 200 });

  if (!listing?.floorPlanImages || isUAExclusiveListingAndNotSignedIn) return null;

  return (
    <Wrapper className={styles.wrapper} width={{ laptop: 'l', tabletLandscape: 'l' }}>
      <div className={styles.floorplanContainer} data-testid="expose-floorplan-slider">
        <Headline
          size="h5"
          as="h2"
          label={formatWithCount(t, 'search.expose.propertyDetails.label.floorPlan', listing.floorPlanImages.length)}
        />
        {shouldLoadLazyLoadedComponent ? (
          <FloorPlanImageSlider images={listing.floorPlanImages ?? []} hasWaterMark={listing.hasWaterMark} />
        ) : (
          <FloorPlanPlaceholder />
        )}
      </div>
    </Wrapper>
  );
};
